// libs
import React from 'react';
// services
import useArtifactService from '../../../artifactService';
// constants
// styles
import { useDocumentStorageContext } from 'framework/documentStorage';
import BaseFilePreviewLayout from './BaseFilePreviewLayout';

type FilePreviewLayoutProps = {
  artifactObject: Dictionary<any>;
  onRemove: () => void;
  children?: Nullable<React.ReactElement>;
  disabled?: boolean;
  isNewDocumentStorage?: boolean;
  budgetId?: StringOrNumber;
};

/**
 * Renders file preview. This component decide which icon to select
 * @param artifactObject - artifact's object
 * @param onRemove - onRemove callback. It'll be called when user click 'x' button near the preview
 * @param children
 * @param disabled
 * @constructor
 */
const FilePreviewLayout: React.FC<FilePreviewLayoutProps> = ({
  artifactObject,
  onRemove,
  children = null,
  disabled = false,
  isNewDocumentStorage,
  budgetId,
}) => {
  const { getThumbnail } = useArtifactService({ budgetId });
  const { getDocumentToken } = useDocumentStorageContext({ ignoreContext: !isNewDocumentStorage });

  const getImageThumbnailSrc = async (artifact: Dictionary<any>, cropSize: string) => {
    if (artifact?.filePreview) {
      return artifact.filePreview;
    } else if (artifact?.thumbnails?.local) {
      return artifact.thumbnails.local;
    } else {
      return isNewDocumentStorage ? await getDocumentToken(artifact.id) : await getThumbnail(artifact.id, cropSize);
    }
  };

  return (
    <BaseFilePreviewLayout
      getImageThumbnail={getImageThumbnailSrc}
      artifactObject={artifactObject}
      onRemove={onRemove}
      children={children}
      disabled={disabled}
    />
  );
};

export default FilePreviewLayout;
